import apiClient from './client';

export interface ProjectDocument {
  id: number;
  job_id: number;
  quote_id?: number;
  document_type: string;
  title: string;
  content_type: string;
  status: 'draft' | 'issued' | 'signed' | 'void';
  version: number;
  issued_date?: string;
  signed_date?: string;
  /** 0 hides the doc from the client portal (CR #128). */
  visible_to_client?: number;
  created_at: string;
  updated_at: string;
}

export const listJobDocuments = async (jobId: string | number): Promise<ProjectDocument[]> => {
  const { data } = await apiClient.get(`/documents/job/${jobId}`);
  return data.data;
};

export const createProjectDocument = async (doc: {
  job_id: number;
  quote_id?: number;
  document_type: string;
  title: string;
  content: string;
  content_type?: string;
}): Promise<ProjectDocument> => {
  const { data } = await apiClient.post('/documents/project', doc);
  return data.data;
};

export const updateProjectDocument = async (
  id: number,
  patch: Partial<{ title: string; content: string; visible_to_client: number }>,
): Promise<void> => {
  await apiClient.put(`/documents/project/${id}`, patch);
};

export const updateDocumentStatus = async (
  id: number,
  status: string,
  opts?: { signed_date?: string; issued_date?: string }
): Promise<void> => {
  await apiClient.patch(`/documents/${id}/status`, { status, ...opts });
};

export const deleteProjectDocument = async (id: number): Promise<void> => {
  await apiClient.delete(`/documents/project/${id}`);
};

export const getDocumentRenderUrl = (id: number): string =>
  `/api/documents/${id}/render`;
